import { extractPrimitiveValue } from '../../../../utils/extractPrimitiveValue';
const convertValueType = (value, type) => {
    if (type === 'date') {
        if (typeof value === 'object') {
            return {
                from: new Date(value.from),
                to: new Date(value.to),
            };
        }
        return new Date(value);
    }
    return (value ?? '');
};
const getValue = (value, column) => {
    if (!value)
        return '';
    if (typeof value === 'object' && 'elements' in value) {
        return {
            value: convertValueType(value.value, column.type),
            breakdown: {
                title: column.breakdown?.label ?? undefined,
                items: Object.entries(value.elements)
                    .map(([key, value]) => {
                    const label = column.breakdown.elements.find(({ id }) => id === key)?.label;
                    if (!label || !value)
                        return;
                    return {
                        label,
                        value: convertValueType(value, column.type),
                    };
                })
                    .filter(Boolean),
            },
        };
    }
    return convertValueType(value, column.type);
};
export const createAnalyticsTableData = (data, columns, sorting) => {
    const tableData = [];
    if (!columns.length || !data?.report) {
        return tableData;
    }
    const reportData = data.report;
    if (reportData.summary) {
        const summaryRow = {};
        Object.entries(reportData.summary).map(([key, value]) => {
            if (value === null)
                return;
            const column = columns.find(({ id }) => id === key);
            if (!column)
                return;
            summaryRow[key] = getValue(value, column);
        });
        tableData.push(summaryRow);
    }
    reportData.rows.forEach((row) => {
        const tableRow = {};
        Object.entries(row).forEach(([key, value]) => {
            const column = columns.find(({ id }) => id === key);
            if (!column)
                return;
            tableRow[key] = getValue(value, column);
        });
        tableData.push(tableRow);
    });
    if (sorting) {
        const sortColumn = columns.find((column) => column.id === sorting.columnId);
        if (sortColumn) {
            tableData.sort((a, b) => {
                const aValue = a[sorting.columnId];
                const bValue = b[sorting.columnId];
                if (a === tableData[0] && reportData.summary) {
                    return -1;
                }
                if (b === tableData[0] && reportData.summary) {
                    return 1;
                }
                const compareValues = (a, b) => {
                    if (sortColumn.type === 'date') {
                        const aDate = a instanceof Date ? a : new Date(a);
                        const bDate = b instanceof Date ? b : new Date(b);
                        if (isNaN(aDate.getTime()) && isNaN(bDate.getTime()))
                            return 0;
                        if (isNaN(aDate.getTime()))
                            return 1;
                        if (isNaN(bDate.getTime()))
                            return -1;
                        return aDate.getTime() - bDate.getTime();
                    }
                    if (sortColumn.type === 'money' || sortColumn.type === 'number') {
                        const aPrimitive = extractPrimitiveValue(a);
                        const bPrimitive = extractPrimitiveValue(b);
                        const aNum = typeof aPrimitive === 'number' ? aPrimitive : 0;
                        const bNum = typeof bPrimitive === 'number' ? bPrimitive : 0;
                        return aNum - bNum;
                    }
                    const aStr = String(a || '');
                    const bStr = String(b || '');
                    return aStr.localeCompare(bStr);
                };
                const comparison = compareValues(aValue, bValue);
                if (sorting.direction === 'asc') {
                    return comparison;
                }
                return -comparison;
            });
        }
    }
    return tableData;
};
